import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { configureStore } from '@eventbrite/redux-configure-store';
import thunk from 'redux-thunk';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { initializeRealUserMonitoring } from '@eventbrite/real-user-monitoring';
import { FeatureFlagsProvider } from '@eventbrite/feature-flag-utils';
import { getInitialData } from './reducers/util';
import reducer from './reducers';
import { ASSORTMENTS_UNFORMATTED_PRICING_PROP_TYPE } from './constants/pricingPropTypes';
import { setLanguage } from '@eventbrite/i18n';
import {
    GA_SETTINGS_PROP_TYPE,
    middleware as analyticsMiddleware,
} from '@eventbrite/site-analytics';

import { getHistory, updateHistory } from '@eventbrite/react-router-history';
import getRoutes from './page/routes';

const isProd = ({ env }) => {
    return env.ebDomain.indexOf('eventbrite') > -1;
};

export default class AssortmentsApp extends Component {
    static propTypes = {
        ...ASSORTMENTS_UNFORMATTED_PRICING_PROP_TYPE,
        gaSettings: GA_SETTINGS_PROP_TYPE,
    };

    constructor(props) {
        super(props);

        setLanguage(props.env.localeInfo.locale);

        const historyManagement = getHistory();
        const historyRouterMiddleware = routerMiddleware(historyManagement);
        const gaAnalyticsMiddleware = analyticsMiddleware(this.props);

        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, historyRouterMiddleware, gaAnalyticsMiddleware],
        });

        this._history = syncHistoryWithStore(historyManagement, this._store);

        updateHistory(this._history, props.request);
    }

    UNSAFE_componentWillReceiveProps({ request }) {
        updateHistory(this._history, request);
    }

    componentDidMount() {
        if (isProd(this.props)) {
            initializeRealUserMonitoring({
                sampleRate: 50,
                version: this.props.app_version,
                service: this.props.app_name,
            });
        }
    }

    render() {
        const {
            env,
            footerLinks,
            request,
            user,
            featureFlags,
            experiments,
            launchNewPackageAndPricing,
        } = this.props;
        const routes = getRoutes(
            {
                env,
                footerLinks,
                request,
                user,
                featureFlags,
                experiments,
            },
            this._store,
        );

        return (
            <Provider store={this._store}>
                <FeatureFlagsProvider
                    value={{
                        ...featureFlags,
                        launchNewPackageAndPricing,
                    }}
                >
                    <Router history={this._history} routes={routes} />
                </FeatureFlagsProvider>
            </Provider>
        );
    }
}
